export default __webpack_public_path__ + "static/media/other_stories_overlay-min.92ddceaa.png";